export const FETCH_API_REQUEST = "FETCH_API_REQUEST";
export const FETCH_API_SUCCESS = "FETCH_API_SUCCESS";
export const FETCH_API_FAILED = "FETCH_API_FAILED";
